module.exports = __webpack_public_path__ + "static/Ai-83214902247a482e4b859c8f0571dbc7.png";